import React from "react";

export default function Members() {
  const members = [
    { uid: "u_1001", email: "owner@acme.com", role: "owner" },
    { uid: "u_1002", email: "admin@acme.com", role: "admin" },
    { uid: "u_1003", email: "member@acme.com", role: "member" },
  ];

  return (
    <div className="grid grid-cols-1 gap-4">
      <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
        <div className="text-base font-semibold mb-2">Members</div>
        <div className="overflow-auto">
          <table className="w-full text-sm">
            <thead className="text-left opacity-70">
              <tr>
                <th className="py-2 pr-4">UID</th>
                <th className="py-2 pr-4">Email</th>
                <th className="py-2 pr-4">Role</th>
                <th className="py-2 pr-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {members.map((m) => (
                <tr key={m.uid} className="border-t border-white/10">
                  <td className="py-2 pr-4 font-mono">{m.uid}</td>
                  <td className="py-2 pr-4">{m.email}</td>
                  <td className="py-2 pr-4">
                    <span className="px-2 py-0.5 rounded-full text-[11px] bg-white/10 border border-white/20">
                      {m.role}
                    </span>
                  </td>
                  <td className="py-2 pr-4">
                    <button className="text-xs px-2 py-1 rounded border border-white/20 bg-white/5 hover:bg-white/10">
                      Change role
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-4">
          <div className="text-sm font-semibold mb-1">Invite member</div>
          <div className="flex gap-2">
            <input
              className="flex-1 bg-black/20 border border-white/20 rounded-xl px-3 py-2 text-sm"
              placeholder="email@company.com"
            />
            <button className="px-3 py-2 rounded-xl border border-white/20 bg-white/10 hover:bg-white/15 text-sm">
              Send Invite
            </button>
          </div>
          <div className="text-xs opacity-60 mt-2">
            Wire this to <span className="font-mono">/orgInvites</span> or a callable Function.
          </div>
        </div>
      </div>
    </div>
  );
}
